<!-- Original tag list layout restored -->
<div class="tag-list d-flex flex-row justify-content-start align-items-center flex-wrap w-100" [ngClass]="{ disabled: disabled }">
  <!-- Empty state when no items selected -->
  <ngx-micetribe-tag [title]="emptyTitle" *ngIf="!!emptyTitle && !displayedTags?.length"></ngx-micetribe-tag>

  <!-- Selected tags display -->
  <ngx-micetribe-tag
    *ngFor="let item of displayedTags; trackBy: trackByFn"
    [title]="getItemDisplayText(item)"
    [isClickable]="listType === 'Languages'"
    (clicked)="onTagClick(item)"
  >
  </ngx-micetribe-tag>

  <!-- Original plus button with popover -->
  <div
    class="tag-menu-button d-flex justify-content-center align-items-center"
    [nbPopover]="menuTemplateRef"
    (nbPopoverShowStateChange)="onPopoverToggle($event)"
    nbPopoverAdjustment="clockwise"
    nbPopoverPlacement="top"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 7.00017C0 7.67684 0.548402 8.22523 1.22546 8.22523H5.77507V12.7749C5.77507 13.4518 6.32366 14.0002 7.00026 14C7.33862 14 7.64489 13.8631 7.86639 13.6415C8.08816 13.4195 8.22526 13.1134 8.22511 12.7753L8.22529 8.22505H12.7755C13.1136 8.22505 13.4196 8.08813 13.6416 7.86618C13.863 7.64478 14 7.33852 14 7.00017C14.0002 6.32361 13.4518 5.7751 12.7748 5.7751H8.22511V1.22534C8.22511 0.54857 7.6764 0 6.99974 0C6.32332 0.000182877 5.7751 0.548204 5.77474 1.22488V5.7751H1.22458C0.548036 5.77547 0.000335693 6.32361 0 7.00017Z"
        fill="#2E3138"
      />
    </svg>
  </div>

  <!-- Improved popover menu template -->
  <ng-template #menuTemplateRef>
    <!-- Default menu (zones, general items) -->
    <div class="tag-list-menu d-flex flex-column" *ngIf="!listType">
      <!-- Search input for many items -->
      <div class="search-container" *ngIf="internalItems.length > 5">
        <input nbInput fullWidth placeholder="Search..." [(ngModel)]="searchTerm" class="search-input" (click)="$event.stopPropagation()" />
        <nb-icon icon="search-outline" class="search-icon"></nb-icon>
      </div>

      <!-- Quick actions -->
      <div class="quick-actions" *ngIf="filteredItems.length > 1">
        <button type="button" class="action-link" (click)="selectAll(); $event.stopPropagation()">Select all</button>
        <button type="button" class="action-link" (click)="clearAll(); $event.stopPropagation()">Clear all</button>
      </div>

      <div class="d-flex flex-column options-container">
        <!-- Checkbox options -->
        <nb-checkbox
          *ngFor="let option of filteredItems; trackBy: trackByFn"
          [disabled]="option.disabled || option.separator"
          (ngModelChange)="toggleItem(option, $event)"
          [ngModel]="option.active"
          [ngClass]="{ indent: option.indent, separator: option.separator }"
          (click)="$event.stopPropagation()"
        >
          {{ getItemDisplayText(option) }}
        </nb-checkbox>
      </div>

      <!-- No options message -->
      <ngx-micetribe-tag [title]="noOptionsTitle" *ngIf="!availableItems.length && !currentItems.length"></ngx-micetribe-tag>

      <!-- Footer -->
      <div class="footer d-flex flex-column">
        <div class="separator"></div>
        <div class="d-flex flex-row justify-content-end align-items-center">
          <button type="button" class="confirm-button flex-grow-0 align-self-end justify-content-center" (click)="applySelection(); $event.stopPropagation()">Done</button>
        </div>
      </div>
    </div>

    <!-- Promo codes menu -->
    <div class="tag-list-menu d-flex flex-column" *ngIf="listType === 'PromoCodes'">
      <!-- Search input -->
      <div class="search-container" *ngIf="internalItems.length > 5">
        <input nbInput fullWidth placeholder="Search codes..." [(ngModel)]="searchTerm" class="search-input" (click)="$event.stopPropagation()" />
        <nb-icon icon="search-outline" class="search-icon"></nb-icon>
      </div>

      <div class="d-flex flex-column options-container">
        <!-- Checkbox options -->
        <nb-checkbox
          *ngFor="let option of filteredItems; trackBy: trackByFn"
          [disabled]="option.disabled || option.separator"
          (ngModelChange)="toggleItem(option, $event)"
          [ngModel]="option.active"
          [ngClass]="{ indent: option.indent, separator: option.separator }"
          (click)="$event.stopPropagation()"
        >
          <div class="promo-item">
            <span class="promo-name">{{ option.name || option.code }}</span>
            <span class="promo-currency" *ngIf="currency">{{ currency }}</span>
          </div>
        </nb-checkbox>
      </div>

      <!-- No options message -->
      <ngx-micetribe-tag [title]="noOptionsTitle" *ngIf="!availableItems.length && !currentItems.length"></ngx-micetribe-tag>

      <!-- Footer -->
      <div class="footer d-flex flex-column">
        <div class="separator"></div>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <button type="button" class="create-button flex-grow-0 align-self-beginning justify-content-center" (click)="openCreatePromoCodeModal(); $event.stopPropagation()">
            Manage discount codes
          </button>
          <button type="button" class="confirm-button flex-grow-0 align-self-end justify-content-center" (click)="applySelection(); $event.stopPropagation()">Done</button>
        </div>
      </div>
    </div>

    <!-- Languages menu -->
    <div class="tag-list-menu d-flex flex-column" *ngIf="listType === 'Languages'">
      <!-- Search input -->
      <div class="search-container" *ngIf="defaultLanguages.length + workspaceLanguages.length > 5">
        <input nbInput fullWidth placeholder="Search languages..." [(ngModel)]="searchTerm" class="search-input" (click)="$event.stopPropagation()" />
        <nb-icon icon="search-outline" class="search-icon"></nb-icon>
      </div>

      <!-- Default languages section -->
      <ng-container *ngIf="customLanguages.length">
        <div class="language-section-title" *ngIf="defaultLanguages.length">Available Languages</div>
        <div class="d-flex flex-column options-container">
          <nb-checkbox
            *ngFor="let option of defaultLanguages; trackBy: trackByFn"
            [disabled]="option.disabled || option.separator || option.name === 'English'"
            (ngModelChange)="toggleItem(option, $event)"
            [ngModel]="option.active || option.name === 'English'"
            [ngClass]="{ indent: option.indent, separator: option.separator }"
          >
            {{ getItemDisplayText(option) }}
          </nb-checkbox>
        </div>
        <!-- Separator -->
        <div class="footer" *ngIf="workspaceLanguages.length">
          <div class="separator"></div>
        </div>

        <!-- Workspace languages section -->
        <div class="language-section-title" *ngIf="workspaceLanguages.length">Custom Languages</div>
        <div class="workspace-language" *ngFor="let option of workspaceLanguages; trackBy: trackByFn">
          <nb-checkbox
            [disabled]="option.disabled || option.separator"
            (ngModelChange)="toggleItem(option, $event)"
            [ngModel]="option.active"
            [ngClass]="{ indent: option.indent, separator: option.separator }"
            (click)="$event.stopPropagation()"
          >
            {{ getItemDisplayText(option) }}
          </nb-checkbox>
          <button
            type="button"
            [nbTooltip]="'Delete language: ' + option.name"
            nbTooltipPlacement="right"
            class="btn btn-sm btn-danger"
            (click)="onDeleteLanguage(option); $event.stopPropagation()"
          >
            &#x2715;
          </button>
        </div>
      </ng-container>

      <!-- Simple list when no custom languages -->
      <ng-container *ngIf="!customLanguages.length">
        <nb-checkbox
          *ngFor="let option of filteredItems; trackBy: trackByFn"
          [disabled]="option.disabled || option.separator || option.name === 'English'"
          (ngModelChange)="toggleItem(option, $event)"
          [ngModel]="option.active || option.name === 'English'"
          [ngClass]="{ indent: option.indent, separator: option.separator }"
          (click)="$event.stopPropagation()"
        >
          {{ getItemDisplayText(option) }}
        </nb-checkbox>
      </ng-container>

      <!-- No options message -->
      <ngx-micetribe-tag [title]="noOptionsTitle" *ngIf="!availableItems.length && !currentItems.length"></ngx-micetribe-tag>

      <!-- Footer -->
      <div class="footer d-flex flex-column">
        <div class="separator"></div>
        <div class="d-flex flex-row justify-content-between align-items-center">
          <button type="button" class="create-button flex-grow-0 align-self-beginning justify-content-center" (click)="onAddClick(); $event.stopPropagation()">Add Language</button>
          <button type="button" class="confirm-button flex-grow-0 align-self-end justify-content-center" (click)="applySelection(); $event.stopPropagation()">Done</button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
